import { useQuery } from '@tanstack/react-query';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import { QueryKeys } from 'utils/queryKeys';
import type { CrmContact } from 'services/company-and-contacts/mappers';

const EMPTY_CRM_CONTACTS: CrmContact[] = [];

export const useSearchCrmContacts = ({ searchTerm, enabled = true }: { searchTerm?: string; enabled?: boolean } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: QueryKeys.searchCrmContacts(searchTerm),
    queryFn: () => ApiCompanyAndContactsRepository.searchCrmContacts({ searchTerm }),
    enabled,
  });
  return { contacts: data ?? EMPTY_CRM_CONTACTS, isLoading, isError, refetch };
};
